"use client"

import { useSystemStatus } from "@src/providers/SystemStatusProvider"
import { useCallback, useEffect, useState } from "react"

const STORAGE_KEY = "system-status-viewed"

function readViewed(): string | null {
  try {
    return sessionStorage.getItem(STORAGE_KEY)
  } catch {
    return null
  }
}

/**
 * Tracks whether the user has already opened the system status details this
 * session, so we can calm the attention ping once viewed.
 */
export function useSystemStatusViewed() {
  const statuses = useSystemStatus()
  const signature = statuses.map((status) => status.id).join("|")

  const [viewed, setViewed] = useState(true)

  useEffect(() => {
    setViewed(signature !== "" && readViewed() === signature)
  }, [signature])

  const markViewed = useCallback(() => {
    if (signature === "") return

    try {
      sessionStorage.setItem(STORAGE_KEY, signature)
    } catch {}

    setViewed(true)
  }, [signature])

  return { viewed, markViewed }
}
